/* LAMY 1.2 — ô tính size trong hướng dẫn đo size (.lsg). Gắn theo kiểu ủy quyền nên chạy được cả trong khung bật lên. */
(function () {
  var mark = function () { document.querySelectorAll('.lsg').forEach(function (g) { g.classList.add('lsg-js'); }); };
  mark();
  new MutationObserver(mark).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-lsg-in]')) return;
    var g = e.target.closest('.lsg'), out = g.querySelector('[data-lsg-out]');
    var rows = Array.prototype.slice.call(g.querySelectorAll('[data-lsg-table] tbody tr'));
    rows.forEach(function (r) { r.classList.remove('is-hit'); });
    var v = parseFloat(String(e.target.value).replace(',', '.'));
    if (!v) { out.innerHTML = ''; return; }
    var c = v < 30 ? v * Math.PI : v, hit = null;
    for (var i = 0; i < rows.length; i++) { if (c < parseFloat(rows[i].dataset.hi) + 1) { hit = rows[i]; break; } }
    if (!hit || c < parseFloat(rows[0].dataset.lo) - 1) { out.innerHTML = 'Ngoài bảng size, bạn nhắn LAMY để được tư vấn nhé.'; return; }
    hit.classList.add('is-hit');
    out.innerHTML = 'Size phù hợp: <b>' + hit.cells[0].textContent + '</b>';
  });
})();
